<ngx-smart-modal
  #cardSelectionDialog
  [class]="modalCls"
  [identifier]="'cardSelectionDialog'"
  [style]="modalStyle"
>
  <div class="body">
    <h2>Card Management options</h2>

    <div class="content">
      <label class="label">Card Management for:</label>
      <workflow-finx-dropdown
        class="card-selection-dropdown"
        [options]="cardList"
        [(ngModel)]="selectionCard"
      >
      </workflow-finx-dropdown>
    </div>
  </div>

  <div class="popup-footer">
    <div class="col-12 text-center">
      <button class="mr-4" (click)="closeAlert()">Cancel</button>
      <button class="positive" (click)="closeAlert()">Add</button>
    </div>
  </div>
</ngx-smart-modal>
